export enum StepsEnum {
    HEADOFTECHNICAL = "HEAD OF TECHNICAL",
    HEADOFQUALTITY = "HEAD OF QUALTITY",
    SAMPLEROOMMANAGER = "SAMPLE ROOM MANAGER",
    MAQWHPROCU = "MAQ (WH/PROCU)",
}

